import { render, staticRenderFns } from "./TicketsTableResponse.vue?vue&type=template&id=5ccfc4ad"
import script from "./TicketsTableResponse.vue?vue&type=script&lang=js"
export * from "./TicketsTableResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports